import { render, staticRenderFns } from "./NewRequest.vue?vue&type=template&id=579a24de&scoped=true"
import script from "./NewRequest.vue?vue&type=script&lang=js"
export * from "./NewRequest.vue?vue&type=script&lang=js"
import style0 from "./NewRequest.vue?vue&type=style&index=0&id=579a24de&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579a24de",
  null
  
)

export default component.exports